const TMenuScreen = {
    // English
    "enUS": {
        'MENUS': 'Menus',
        'POLL': 'Poll',
        'CUSTOMIZE': 'Customize',
        'EDIT': 'Edit',
        'ENABLED': 'Enabled',
        'DISABLED': 'Disabled',
        'NAME': 'Name',
        'SEARCH': 'Search',
        'SEARCH_FOOD': 'Search food',
        'SHOW': 'Show',
        'ACTIVE': 'Active',
        'INACTIVE': 'Inactive',
        'NEW_MENU': 'New Menu',
        'LOAD_MORE': 'Load More',
        'CANCEL': 'Cancel',
        'SAVE': 'Save',
        'NO_FOOD': 'No food found',
        'NOT_FOUND': "The menu doesn't exist",
        'ATLEAST_THREE_LETTERS': 'Write at least three letters to search',
        'SUB_EXPIRED': 'Your subscription has expired, to use your digital menu sign in and add a payment method',
        'POLL_MSG': 'Answer poll',
    },
    // Spanish
    "esMX": {
        'MENUS': 'Menús',
        'POLL': 'Encuesta',
        'CUSTOMIZE': 'Apariencia',
        'EDIT': 'Editar',
        'ENABLED': 'Activo',
        'DISABLED': 'Inactivo',
        'NAME': 'Nombre',
        'SEARCH': 'Buscar',
        'SEARCH_FOOD': 'Buscar alimentos',
        'SHOW': 'Mostrar',
        'ACTIVE': 'Activo',
        'INACTIVE': 'Inactivo',
        'NEW_MENU': 'Nuevo Menú',
        'LOAD_MORE': 'Cargar Más',
        'CANCEL': 'Cancelar',
        'SAVE': 'Guardar',
        'NO_FOOD': 'No se encontraron alimentos',
        'NOT_FOUND': "El menú no existe",
        'ATLEAST_THREE_LETTERS': 'Escribe al menos tres letras para buscar',
        'SUB_EXPIRED': 'Tu suscripción ha expirado, para seguir usando tu menú digital inicia sesión y agrega un método de pago',
        'POLL_MSG': 'Responder encuesta',
    }
}
export default TMenuScreen;